export var BootstrapGridBreakpoints;
(function (BootstrapGridBreakpoints) {
    BootstrapGridBreakpoints[BootstrapGridBreakpoints["ExtraSmall"] = 0] = "ExtraSmall";
    BootstrapGridBreakpoints[BootstrapGridBreakpoints["Small"] = 576] = "Small";
    BootstrapGridBreakpoints[BootstrapGridBreakpoints["Medium"] = 768] = "Medium";
    BootstrapGridBreakpoints[BootstrapGridBreakpoints["Large"] = 992] = "Large";
    BootstrapGridBreakpoints[BootstrapGridBreakpoints["ExtraLarge"] = 1200] = "ExtraLarge";
})(BootstrapGridBreakpoints || (BootstrapGridBreakpoints = {}));
